
/* injects from baggage-loader */

'use strict';

export default class ProjectUpdateController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
